import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadTrialInstitutionLaboratoryContractByTrialInstitutionLaboratoryId: ITrialInstitutionLaboratoryContractLoadByTrialInstitutionLaboratoryIdActionCreator = (trialInstitutionLaboratoryId) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_LOAD_BY_TRIAL_INSTITUTION_LABORATORY_ID,
            trialInstitutionLaboratoryId
        }
    },
    LoadTrialInstitutionLaboratoryContractById: ITrialInstitutionLaboratoryContractLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: ITrialInstitutionLaboratoryContractLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ITrialInstitutionLaboratoryContractLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveTrialInstitutionLaboratoryContract: ITrialInstitutionLaboratoryContractSaveActionCreator = (formData) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_SAVE,
            formData
        }
    },
    SaveSuccess: ITrialInstitutionLaboratoryContractSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ITrialInstitutionLaboratoryContractSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_SAVE_FAILURE,
            responseStatus
        }
    },

    ValidateTrialInstitutionLaboratoryContract: ITrialInstitutionLaboratoryContractValidateActionCreator = (formData) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ITrialInstitutionLaboratoryContractValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ITrialInstitutionLaboratoryContractValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_VALIDATE_FAILURE,
            responseStatus
        }
    },

    CreateTrialInstitutionLaboratoryContract: ITrialInstitutionLaboratoryContractCreateActionCreator = (trialInstitutionLaboratoryId) => {

        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_CREATE,
            trialInstitutionLaboratoryId
        }
    },
    CreateSuccess: ITrialInstitutionLaboratoryContractCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ITrialInstitutionLaboratoryContractCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_CREATE_FAILURE,
            responseStatus
        }
    },

    DeleteTrialInstitutionLaboratoryContract: ITrialInstitutionLaboratoryContractDeleteActionCreator = (id) => {
    
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_DELETE,
            id
        }
    },
    DeleteSuccess: ITrialInstitutionLaboratoryContractDeleteSuccessActionCreator = () => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_DELETE_SUCCESS
        }
    },
    DeleteFailure: ITrialInstitutionLaboratoryContractDeleteFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_DELETE_FAILURE,
            responseStatus
        }
    },

    Clear: ITrialInstitutionLaboratoryContractClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_CLEAR,
            propertiesToClear
        }
    },

    Filter: ITrialInstitutionLaboratoryContractFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_FILTER,
            formFilter
        }
    };



export const
    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_LOAD_BY_TRIAL_INSTITUTION_LABORATORY_ID = "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_LOAD_BY_TRIAL_INSTITUTION_LABORATORY_ID",
    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_LOAD_BY_ID = "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_LOAD_BY_ID",
    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_LOAD_SUCCESS = "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_LOAD_SUCCESS",
    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_LOAD_FAILURE = "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_LOAD_FAILURE",

    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_SAVE = "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_SAVE",
    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_SAVE_SUCCESS = "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_SAVE_SUCCESS",
    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_SAVE_FAILURE = "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_SAVE_FAILURE",

    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_VALIDATE = "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_VALIDATE",
    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_VALIDATE_SUCCESS = "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_VALIDATE_SUCCESS",
    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_VALIDATE_FAILURE = "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_VALIDATE_FAILURE",

    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_CREATE = "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_CREATE",
    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_CREATE_SUCCESS = "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_CREATE_SUCCESS",
    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_CREATE_FAILURE = "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_CREATE_FAILURE",

    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_DELETE = "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_DELETE",
    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_DELETE_SUCCESS = "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_DELETE_SUCCESS",
    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_DELETE_FAILURE = "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_DELETE_FAILURE",

    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_CLEAR = "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_CLEAR",

    ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_FILTER = "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_FILTER";

export interface ITrialInstitutionLaboratoryContractLoadByTrialInstitutionLaboratoryIdAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_LOAD_BY_TRIAL_INSTITUTION_LABORATORY_ID";
    trialInstitutionLaboratoryId: number;
}

export interface ITrialInstitutionLaboratoryContractLoadByTrialInstitutionLaboratoryIdActionCreator {
    (trialInstitutionLaboratoryId: number): ITrialInstitutionLaboratoryContractLoadByTrialInstitutionLaboratoryIdAction;
}

export interface ITrialInstitutionLaboratoryContractLoadSuccessAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_LOAD_SUCCESS";
    formData: Dtos.TrialInstitutionLaboratoryContract | Dtos.TrialInstitutionLaboratoryContract[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionLaboratoryContractLoadSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionLaboratoryContract | Dtos.TrialInstitutionLaboratoryContract[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialInstitutionLaboratoryContractLoadSuccessAction;
}

export interface ITrialInstitutionLaboratoryContractLoadFailureAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionLaboratoryContractLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryContractLoadFailureAction;
}

export interface ITrialInstitutionLaboratoryContractLoadByIdAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_LOAD_BY_ID";
    id: number;
}

export interface ITrialInstitutionLaboratoryContractLoadByIdActionCreator {
    (id: number): ITrialInstitutionLaboratoryContractLoadByIdAction;
}

export interface ITrialInstitutionLaboratoryContractSaveAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_SAVE";
    formData: Dtos.TrialInstitutionLaboratoryContract;

}

export interface ITrialInstitutionLaboratoryContractSaveActionCreator {
    (
        formData: Dtos.TrialInstitutionLaboratoryContract
    ): ITrialInstitutionLaboratoryContractSaveAction;
}

export interface ITrialInstitutionLaboratoryContractSaveSuccessAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_SAVE_SUCCESS";
    formData: Dtos.TrialInstitutionLaboratoryContract;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionLaboratoryContractSaveSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionLaboratoryContract,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialInstitutionLaboratoryContractSaveSuccessAction;
}

export interface ITrialInstitutionLaboratoryContractSaveFailureAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionLaboratoryContractSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryContractSaveFailureAction;
}

export interface ITrialInstitutionLaboratoryContractValidateAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_VALIDATE";
    formData: Dtos.TrialInstitutionLaboratoryContract;

}

export interface ITrialInstitutionLaboratoryContractValidateActionCreator {
    (
        formData: Dtos.TrialInstitutionLaboratoryContract
    ): ITrialInstitutionLaboratoryContractValidateAction;
}

export interface ITrialInstitutionLaboratoryContractValidateSuccessAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_VALIDATE_SUCCESS";
    formData: Dtos.TrialInstitutionLaboratoryContract;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialInstitutionLaboratoryContractValidateSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionLaboratoryContract,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialInstitutionLaboratoryContractValidateSuccessAction;
}

export interface ITrialInstitutionLaboratoryContractValidateFailureAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionLaboratoryContractValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryContractValidateFailureAction;
}

export interface ITrialInstitutionLaboratoryContractCreateAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_CREATE",
    trialInstitutionLaboratoryId: number
}

export interface ITrialInstitutionLaboratoryContractCreateActionCreator {
    (trialInstitutionLaboratoryId: number): ITrialInstitutionLaboratoryContractCreateAction
}

export interface ITrialInstitutionLaboratoryContractCreateSuccessAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_CREATE_SUCCESS";
    formData: Dtos.TrialInstitutionLaboratoryContract;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface ITrialInstitutionLaboratoryContractCreateSuccessActionCreator {
    (
        formData: Dtos.TrialInstitutionLaboratoryContract,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ITrialInstitutionLaboratoryContractCreateSuccessAction;
}

export interface ITrialInstitutionLaboratoryContractCreateFailureAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionLaboratoryContractCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryContractCreateFailureAction;
}

export interface ITrialInstitutionLaboratoryContractDeleteAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_DELETE";
    id: number;
}

export interface ITrialInstitutionLaboratoryContractDeleteActionCreator {
    (id: number): ITrialInstitutionLaboratoryContractDeleteAction
}

export interface ITrialInstitutionLaboratoryContractDeleteSuccessAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_DELETE_SUCCESS";
}

export interface ITrialInstitutionLaboratoryContractDeleteSuccessActionCreator {
    (): ITrialInstitutionLaboratoryContractDeleteSuccessAction;
}

export interface ITrialInstitutionLaboratoryContractDeleteFailureAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_DELETE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialInstitutionLaboratoryContractDeleteFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialInstitutionLaboratoryContractDeleteFailureAction;
}

export interface ITrialInstitutionLaboratoryContractClearAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_CLEAR";
    propertiesToClear?: string[];
}

export interface ITrialInstitutionLaboratoryContractClearActionCreator {
    (propertiesToClear?: string[]): ITrialInstitutionLaboratoryContractClearAction;
}

export interface ITrialInstitutionLaboratoryContractFilterActionCreator {
    (formFilter: IFormFilter): ITrialInstitutionLaboratoryContractFilterAction;
}

export interface ITrialInstitutionLaboratoryContractFilterAction {
    type: "ACTION_TRIALINSTITUTIONLABORATORYCONTRACT_FILTER";
    formFilter: IFormFilter;
}

export type TrialInstitutionLaboratoryContractAction =
    ITrialInstitutionLaboratoryContractLoadByTrialInstitutionLaboratoryIdAction |
    ITrialInstitutionLaboratoryContractLoadByIdAction |
    ITrialInstitutionLaboratoryContractLoadFailureAction |
    ITrialInstitutionLaboratoryContractLoadSuccessAction |
    ITrialInstitutionLaboratoryContractSaveAction |
    ITrialInstitutionLaboratoryContractSaveSuccessAction |
    ITrialInstitutionLaboratoryContractSaveFailureAction |
    ITrialInstitutionLaboratoryContractValidateAction |
    ITrialInstitutionLaboratoryContractValidateSuccessAction |
    ITrialInstitutionLaboratoryContractValidateFailureAction |
    ITrialInstitutionLaboratoryContractCreateAction |
    ITrialInstitutionLaboratoryContractCreateSuccessAction |
    ITrialInstitutionLaboratoryContractCreateFailureAction |
    ITrialInstitutionLaboratoryContractDeleteAction |
    ITrialInstitutionLaboratoryContractDeleteSuccessAction |
    ITrialInstitutionLaboratoryContractDeleteFailureAction |
    ITrialInstitutionLaboratoryContractClearAction | 
    ITrialInstitutionLaboratoryContractFilterAction;
